module.exports = __webpack_public_path__ + "img/ringba-phone-number-link-and-button.7aad94b1.svg";